import { GLOBAL_UI_ACTION_TYPE } from 'store/global/actions';

const initialState = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
};

const globalUiReducer = function (state = initialState, { type, payload }) {
  switch (type) {
    case GLOBAL_UI_ACTION_TYPE.SET_SCREEN_INFO:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default globalUiReducer;
